import {showLoader, hideLoader} from './app'
import axios from 'axios'
import Cookies from 'js-cookie'
import * as Sentry from '@sentry/react'
import {emailIsValid, emailIsSpammer, namesAreValid} from 'core/utils/checkEmailNamePatterns'

function onLoginResponse (response, callback = null) {
  if (response.status === 200) {
    if (response.data.redirect && !callback) {
      window.location.replace(response.data.redirect)
      if (response.data.redirect.indexOf('#') !== -1) {
        window.location.reload()
      }

      return
    }

    window.location.href = window.location.href.replace(`#${window.location.hash}`, '')

    // This callback allow us to know when the user is logged.
    if (callback) {
      callback()
    }

    return window.location.href
  }

  return console.error('Something happened, handle errors')
}

function tfaRegister (data) {
  if (data.data.enableTFA === 'true' || data.data.enableTFA === 'false') {
    return true
  }

  window.onTFAflowComplete = function () {}

  return new Promise(resolve => window.gigya.accounts.showScreenSet({
    screenSet: 'tfaRegistrationLogin',
    startScreen: 'gigya-complete-registration-screen',
    onHide: () => resolve(true)
  }))
}

async function onLoginHandler (data, redirectTo = null, callback) {
  Sentry.setUser({email: data.profile.email})

  if (redirectTo) Cookies.set('redirect-to', redirectTo)
  try {
    await tfaRegister(data)

    const response = await axios.post('/login', {...data})

    onLoginResponse(response, callback)
  } catch (e) {
    throw new Error(e)
  }
}

function manualLogin (data) {
  return dispatch => {
    onLoginResponse(data)
    dispatch(showLoader())
  }
}

function login (redirectTo = null, callback = null) {
  return dispatch => {
    window.gigya.accounts.showScreenSet({
      screenSet: 'Login-web-2',
      onHide: e => {
        if (e.reason === 'canceled') {
          dispatch(hideLoader())
        }
      },
      onAfterScreenLoad: e => {
        document.querySelector('.gigya-screen-dialog-mobile').querySelector('form').querySelector('input').blur()
      },
      onBeforeValidation: async e => {
        let email = e.formData.loginID ? e.formData.loginID : e.formData.email
        let firstName = e.formData['profile.firstName']
        let lastName = e.formData['profile.lastName']

        var errors = {
          spamEmailError: {'form': 'This email address already exists.'},
          emailError: {'form': 'For security reasons, you cannot use email addresses that resemble AKC products.'},
          nameError: {'form': 'That name is already in use. Please try another name.'}
        }

        let spamEmailError = (e.screen == "gigya-register-screen") ? await emailIsSpammer(email) : false
        let emailError = !emailIsValid(email)
        let nameError = !namesAreValid(firstName, lastName)

        if (emailError || nameError || spamEmailError) {
          document.querySelector('.gigya-error-display').style.display = 'block'

          if (spamEmailError) {
            return errors.spamEmailError
          }

          if (emailError) {
            return errors.emailError
          }

          if (nameError) {
            return errors.nameError
          }
        }

        return null
      }
    })

    dispatch(showLoader())
    window.gigya.accounts.addEventHandlers({
      onLogin: response => {
        // Inadvertently causes /login to be called twice
        // onLoginHandler(response, redirectTo, callback)
      }
    })
  }
}

function signUp (redirectTo = null, callback = null) {
  return dispatch => {
    window.gigya.accounts.showScreenSet({
      screenSet: 'Login-web-2',
      startScreen: 'gigya-register-screen',
      onHide: e => {
        if (e.reason === 'canceled') {
          dispatch(hideLoader())
        }
      },
      onAfterScreenLoad: e => {
        document.querySelector('.gigya-screen-dialog-mobile').querySelector('form').querySelector('input').blur()
      },
      onBeforeValidation: e => {
        let email = e.formData.loginID ? e.formData.loginID : e.formData.email
        let firstName = e.formData['profile.firstName']
        let lastName = e.formData['profile.lastName']

        var errors = {
          emailError: {'form': 'For security reasons, you cannot use email addresses that resemble AKC products.'},
          nameError: {'form': 'That name is already in use. Please try another name.'}
        }

        let emailError = !emailIsValid(email)
        let nameError = !namesAreValid(firstName, lastName)

        if (emailError || nameError) {
          document.querySelector('.gigya-error-display').style.display = 'block'

          if (emailError) {
            return errors.emailError
          }

          if (nameError) {
            return errors.nameError
          }
        }

        return null
      }
    })

    dispatch(showLoader())

    window.gigya.accounts.addEventHandlers({
      onLogin: response => {
        onLoginHandler(response, redirectTo, callback)
      }
    })
  }
}

function logout (isSuperUser = false, alreadyLoggedOutInGigya = false) {
  return async dispatch => {
    try {
      dispatch(showLoader())

      await axios.post('/logout')

      let newUrl = window.location.href
      newUrl = newUrl.replace(`#${window.location.hash}`, '')

      if (window.location.href.indexOf('account') >= 0 || window.location.href.indexOf('onboarding') >= 0) {
        newUrl = '/'
      }
      newUrl = newUrl.replace(`#${window.location.hash}`, '')

      // Do not logout from Gigya.
      if (isSuperUser) {
        window.location.replace(newUrl)

        return false
      }

      if (alreadyLoggedOutInGigya) return window.location.replace(newUrl)

      return window.gigya.accounts.logout({
        callback: function () {
          window.location.replace(newUrl)
        }
      })
    } catch (e) {
      throw new Error(e)
    }
  }
}

function loginWithoutModal (response) {
  // If email is not trusted
  if (!emailIsValid(response.profile.email)) {
    throw new Error('For security reasons, you cannot use email addresses that resemble AKC products.')
  }

  return dispatch => {
    dispatch(showLoader())
    onLoginHandler(response, null, null)
  }
}

export {login, loginWithoutModal, manualLogin, signUp, logout, onLoginResponse, tfaRegister}
